export default {
  toastSaveTitle: {
    id: 'favorites_toast_save_title',
    defaultMessage: 'Saved and faved!',
  },
  toastSaveDescription: {
    id: 'favorites_toast_save_description',
    defaultMessage: '(And a cheesy rhyme to boot)',
  },
  toastSaveActionText: {
    id: 'favorites_toast_save_button_label',
    defaultMessage: 'See my favorites',
  },

  toastAlreadySavedTitle: {
    id: 'favorites_toast_already_saved_title',
    defaultMessage: 'Welcome again!',
  },
  toastAlreadySavedDescription: {
    id: 'favorites_toast_already_saved_description',
    defaultMessage: 'You faved this product one day',
  },
  toastAlreadySaveActionText: {
    id: 'favorites_toast_already_saved_button_label',
    defaultMessage: 'See my favorites',
  },

  toastUndoTitle: {
    id: 'favorites_toast_undo_title',
    defaultMessage: 'Not ready to say goodbye?',
  },
  toastUndoDescription: {
    id: 'favorites_toast_undo_description',
    defaultMessage: 'Press undo.',
  },
  toastUndoActionText: {
    id: 'favorites_toast_undo_button_label',
    defaultMessage: 'Undo',
  },

  toastAddToCartTitle: {
    id: 'favorites_add_to_cart_toast_title',
    defaultMessage: 'Yuhuu!',
  },
  toastAddToCartDescription: {
    id: 'favorites_add_to_cart_toast_description',
    defaultMessage: 'Item added to cart',
  },

  toastClose: {
    id: 'toast_close_alternative_text',
    defaultMessage: 'Close',
  },
}
